import { render } from "./DashboardUpdate.vue?vue&type=template&id=5f96f499"
import script from "./DashboardUpdate.vue?vue&type=script&lang=js"
export * from "./DashboardUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__